<template>
  <section class="tech-panel guide-list-panel">
    <div class="panel-title list-title">区域指导清单</div>
    <div class="guide-table">
      <div v-for="item in tableItems" :key="item">{{ item }}</div>
    </div>
  </section>
</template>

<script setup>
const tableItems = [
  "乡镇 / 作物",
  "阶段",
  "指导措施",
  "崇礼乡 / 红薯",
  "蔓长期",
  "控旺促根",
  "无量寺乡 / 花生",
  "开花下针期",
  "轻施钙肥",
];
</script>

<style lang="less" scoped>
@import "./guidancePanelShared.less";

.guide-list-panel {
  height: 178px;
  flex-shrink: 0;
  padding: 42px 32px 22px;
}

.list-title {
  position: absolute;
  top: -33px;
  left: 50%;
  width: 320px;
  margin: 0;
  transform: translateX(-50%);
}

.guide-table {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 0.95fr;
  grid-template-rows: repeat(3, 1fr);
  border-top: 1px solid rgba(73, 255, 238, 0.55);
  border-left: 1px solid rgba(73, 255, 238, 0.55);
}

.guide-table div {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  border-right: 1px solid rgba(73, 255, 238, 0.55);
  border-bottom: 1px solid rgba(73, 255, 238, 0.55);
  color: #ffffff;
  font-size: 26px;
  font-weight: bold;
  line-height: 34px;
  background: rgba(0, 79, 70, 0.25);
}

.guide-table div:nth-child(-n + 3) {
  color: #65fff1;
  background: rgba(29, 183, 159, 0.3);
}
</style>
